var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iv2-news-item__line col-12",class:_vm.current},[_c('router-link',{staticClass:"iv2-news-item__link",attrs:{"to":{
        name: 'newsDetail',
        params: { id: _vm.content.id },
        query: Object.assign({}, _vm.$route.query),
      }}},[_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"iv2-news-item__date",class:{
            'col-md-3 text-left': _vm.current == 'top',
            'col-6 col-md-3 text-xl-center': _vm.current == 'news-list',
          }},[_vm._v(" "+_vm._s(_vm.content.opened_at)+" ")]),_c('div',{class:{
            'col-md-9': _vm.current == 'top',
            'col-md-9 col-lg-3': _vm.current == 'news-list',
          }},[_c('small',{staticClass:"iv2-news-item__category theme__badge-bg"},[_vm._v(_vm._s(_vm.content.category_name))]),(!_vm.content.days_excess)?_c('span',{staticClass:"iv2-news-item__new size-14",class:{
              'd-inline-block': _vm.current == 'top',
              'd-none': _vm.current == 'news-list',
            }},[_vm._v(" "+_vm._s(_vm.$store.state.themeLang.general.new_label)+" ")]):_vm._e()]),_c('div',{staticClass:"iv2-news-item__title pt-2",class:{
            'col-xl-12': _vm.current == 'top',
            'col-lg-6': _vm.current == 'news-list',
          }},[_vm._v(" "+_vm._s(_vm.content.title)+" "),(!_vm.content.days_excess)?_c('span',{staticClass:"iv2-news-item__new size-14",class:{
              'd-none': _vm.current == 'top',
              'd-inline-block': _vm.current == 'news-list',
            }},[_vm._v(" "+_vm._s(_vm.$store.state.themeLang.general.new_label)+" ")]):_vm._e()])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }